import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { CustomAxiosRequestConfig } from 'scbk-services/types/http/axios-extension';
import { AxiosInstanceManager } from '../managers/axios-instance-manager';
import { buildBsoiError } from '../utils/bsoi-response-handler';

/**
 *
 */
class BsoiService {
    private static instance: BsoiService | null = null;
    private axiosClient!: AxiosInstance;

    /**
     *
     * @param baseUrl
     * @returns
     */
    constructor(baseUrl: string) {
        if (BsoiService.instance) {
            BsoiService.instance.axiosClient = AxiosInstanceManager.getCommonAxiosInstance(baseUrl);
            return BsoiService.instance;
        }

        this.axiosClient = AxiosInstanceManager.getCommonAxiosInstance(baseUrl);
        this.addInterceptors();

        BsoiService.instance = this;
    }

    /**
     *
     */
    private addInterceptors = () => {
        this.axiosClient.interceptors.request.use(
            (config: CustomAxiosRequestConfig) => {
                return config;
            },
            (error) => Promise.reject(error),
        );

        this.axiosClient.interceptors.response.use(
            (response) => {
                return Promise.resolve(response);
            },
            (error) => Promise.reject(buildBsoiError(error)),
        );
    };

    /**
     *
     * @param method
     * @param url
     * @param data
     * @param config
     * @returns
     */
    private async request<T>(
        method: string,
        url: string,
        data?: unknown,
        config?: AxiosRequestConfig,
    ): Promise<T> {
        const response: AxiosResponse<T> = await this.axiosClient.request({
            method,
            url,
            data,
            ...config,
        });
        return response.data;
    }

    public async get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
        return this.request<T>('GET', url, undefined, config);
    }

    public async post<T>(url: string, data: unknown, config?: AxiosRequestConfig): Promise<T> {
        return this.request<T>('POST', url, data, config);
    }

    public async put<T>(url: string, data: unknown, config?: AxiosRequestConfig): Promise<T> {
        return this.request<T>('PUT', url, data, config);
    }

    public async delete<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
        return this.request<T>('DELETE', url, undefined, config);
    }
}

export { BsoiService };
